import { useEffect, useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { useNavigate, useParams } from 'react-router-dom';
import type { NoticeItem } from '../../shared/data/constants';
import { drumLanguageAtom, drumSelectedNoticeAtom } from '../../shared/store/drumAppAtoms';
import { fetchPublicNotice } from '../../shared/api/memberApi';
import { formatProfileDate } from '../../shared/utils/drumHelpers';
import './NoticeDetail.scss';

function NoticeDetail() {
  const { noticeId } = useParams();
  const language = useAtomValue(drumLanguageAtom);
  const [selectedNotice, setSelectedNotice] = useAtom(drumSelectedNoticeAtom);
  const navigate = useNavigate();
  const [notice, setNotice] = useState<NoticeItem | null>(
    selectedNotice && selectedNotice.id === noticeId ? selectedNotice : null,
  );
  const [isLoading, setIsLoading] = useState(!notice);

  useEffect(() => {
    if (!noticeId) {
      navigate('/drum/profile/notices', { replace: true });
      return undefined;
    }

    if (notice && notice.id === noticeId) {
      setSelectedNotice(notice);
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);
    fetchPublicNotice(noticeId)
      .then((item) => {
        if (cancelled) return;
        setNotice(item);
        setSelectedNotice(item);
      })
      .catch(() => {
        if (!cancelled) navigate('/drum/profile/notices', { replace: true });
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [noticeId]);

  if (isLoading || !notice) return <div className="page profile-subpage"><p className="empty-list">Loading...</p></div>;

  return (
    <div className="page profile-subpage notice-detail-page">
      <article className="notice-detail">
        <div className="notice-detail-meta"><span>{notice.tag}</span><time><strong>Published</strong>{formatProfileDate(notice.date, language)}</time></div>
        <h1>{notice.title}</h1>
        <div className="notice-body">
          {notice.body.map((paragraph, index) => (
            <p key={`${index}-${paragraph}`}>{paragraph}</p>
          ))}
        </div>
      </article>
    </div>
  );
}

export default NoticeDetail;
